const defaults = {
  email: '',
  firstName: '',
  lastName: '',
  userName: '',
  address: {
    street: '',
    zipCode: '',
    city: ''
  },
  isFetched: false,
  error: null
};

function userDetails(state = defaults, action) {
  switch (action.type) {
    case 'USERDETAILS_FETCHING':
      return { ...defaults };

    case 'USERDETAILS_FETCHED':
      return { ...state, ...action.data, isFetched: true };

    case 'USERDETAILS_ERROR':
      return { ...state, error: action.error, isFetched: true };

    case 'USERDETAILS_RESET':
      return { ...defaults };
  }

  return state;
}

export default userDetails;



// WEBPACK FOOTER //
// ./web/js/stores/reducers/userDetails.js